import { runInAction } from 'mobx';
import { Request, Response } from '../../system/utilities/network.js';
import { toJS } from 'mobx';
import moment from 'moment';

const ddtList = async function(params,options){

  let loadingKey = 'ddtlist';
  let localParams = this.routeParamsCacheGet("ddtParams"); 
  let dates = this.rangeToDates(this.config.format.dateRangeDefault);

  let  _params = {
    "PageNumber": localParams.PageNumber || 1,
    "da_dt_bolla": localParams.da_dt_bolla || dates.fr,
    "a_dt_bolla": localParams.a_dt_bolla || dates.to
  }


  // spinner
  this.loadingAdd(loadingKey);

  // API call
  let response = await this.dataLayer({
    url: this.config.paths.apiURL + 'ddt',
    cacheAge: options && options.cacheAge ? options.cacheAge : this.config.cacheAPI.default,
    params: _params,
    userToken: this.userToken
  });

  // business logic
  runInAction( ()=> {
    if(response){
      this.dataDDT = response.data;
    }
    this.loadingRemove(loadingKey);
  });

}

export {ddtList}